import React, { useMemo } from 'react'
import styled from '@emotion/styled'
import { useTeam } from '../../data/team'

const ResultButton = styled('button')`
    border-radius: 50%;
    display: block;
    width: 1.25rem;
    height: 1.25rem;
    background-color: ${({ result }) => {
        switch (result) {
            case 'draw':
                return 'var(--colors-warning)'
            case 'win':
                return 'var(--colors-success)'
            case 'loss':
                return 'var(--colors-failure)'
            default:
                return 'var(--colors-grays-80)'
        }
    }};

    border: var(--borders-main);
    /* border: ${({ isActive }) => (isActive ? '1px solid yellow' : 'none')}; */
    opacity: ${({ isActive }) => (isActive ? '1' : '0.5')};
    transition: 0.2s ease opacity;
    &:hover {
        opacity: 0.8;
    }
`
export const TeamMenuItem = ({
    match,
    selectedPlayedMatch,
    setSelectedPlayedMatch,
    team,
}) => {
    const results = match.officialResults || match.unofficialResults
    const [{ activeTeam: _activeTeam }] = useTeam()
    const activeTeam = team || _activeTeam
    const {
        homeTeam = match.homeTeam,
        awayTeam = match.awayTeam,
        isActiveTeam,
    } = match?.teams?.reduce((acc, cv) => {
        if (cv.isHomeTeam) {
            const isActiveTeam =
                cv?.team?._id === (activeTeam?._id || activeTeam)
            return { ...acc, homeTeam: cv, isActiveTeam }
        }
        return { awayTeam: cv, ...acc }
    }, {}) || {}
    const { homeTeamScore, awayTeamScore } = useMemo(() => {
        if (match.officialResults) {
            return match.officialResults
        }
        if (match.logs) {
            let home = 0
            let away = 0
            match.logs.forEach((e) => {
                if (e.eventType === 'goalScored') {
                    return e?.team?.isHomeTeam ? ++home : ++away
                }
            })
            if (home || away) {
                return { homeTeamScore: home, awayTeamScore: away }
            }
            if (match.unofficialResults) {
                return match.unofficialResults
            }
            return {}
        }
    }, [match.officialResults, match.logs])
    const tableOutcome = useMemo(() => {
        if (homeTeamScore === awayTeamScore) {
            return { away: 1, home: 1 }
        }

        return homeTeamScore > awayTeamScore
            ? { home: 3, away: 0 }
            : { away: 3, home: 0 }
    }, [results])
    const teamResult = useMemo(
        () =>
            homeTeam && (!isActiveTeam ? tableOutcome.away : tableOutcome.home),
        [tableOutcome.away]
    )
    if (typeof homeTeamScore == 'undefined') {
        return (
            <ResultButton
                key={match._id}
                onClick={() => setSelectedPlayedMatch(match)}
                result="unknown"
            ></ResultButton>
        )
    }
    const result = { 0: 'loss', 3: 'win', 1: 'draw' }['' + teamResult]
    console.log(result)
    return (
        <ResultButton
            key={match._id}
            className={'teamresults' + teamResult}
            result={result}
            onClick={() => setSelectedPlayedMatch(match)}
            isActive={match._id === selectedPlayedMatch._id}
        ></ResultButton>
    )
}
